/**
 * @generated SignedSource<<d6ab9c8a5ba80b181c564f79e8cbb221>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "VibePost",
    "kind": "LinkedField",
    "name": "unshareVibePost",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "removed",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "VibePost",
        "kind": "LinkedField",
        "name": "sharedPost",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sharesCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sharedByCurrentUser",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "postItemFeaturesMenuUnshareVibePostMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "postItemFeaturesMenuUnshareVibePostMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "a548141359c364379e955abed9da643c",
    "id": null,
    "metadata": {},
    "name": "postItemFeaturesMenuUnshareVibePostMutation",
    "operationKind": "mutation",
    "text": "mutation postItemFeaturesMenuUnshareVibePostMutation(\n  $request: ShareVibePostRequestInput!\n) {\n  unshareVibePost(request: $request) {\n    id\n    removed\n    sharedPost {\n      id\n      sharesCount\n      sharedByCurrentUser\n    }\n  }\n}\n"
  }
};
})();

node.hash = "82e6c0e5540fe2132a169fcc5c1f9b9f";

module.exports = node;
